module.exports = __webpack_public_path__ + "fonts/Flaticon2.5c31a036.woff";